<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Loyal to the Sky</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="chapter" id="d14e113">
<p id="d7e2227"><br/><span class="small">AUTHOR’S NOTE</span></p>
<p id="d7e2277"><br/> The accounts in this book are all based on real people and events, but some have been condensed or conflated. Names have been changed in some places, and a few of the characters are composites. I have on occasion altered the setting or timing of a revelation or personal experience. But throughout the book I have searched for and striven to relate the heart of the story—my own, as well as those of the individuals and communities I have been blessed to encounter along the way.<br/><br/></p>
<p id="d7e2507"><br/> Page vii used by permission of Joanna Macy</p>
<p id="d7e2557"><br/> The illustration for the <span href="#/SanFrancisco" title="Link target outside of Sample">poster</span> appears by permission of the artist, Mona Caron. © 2003 by Mona Caron. The text for the poster was written by Chris Carlsson and is used with his permission. © 2003 by Chris Carlsson.</p>
<p id="d7e2777"><br/> Full texts of the article by Patrick Reinsborough mentioned in chapter 7 and the article by Ilyse Hogue and Patrick Reinsborough mentioned in chapter 8 are posted at <a href="http://www.smartmeme.com" id="d14e132" target="_blank">www.smartmeme.com</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AUTHORSNOTE.vue?67924fa8